module.exports = __webpack_public_path__ + "static/media/info-circle.5ea5f4e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/info-circle.svg
// module id = 193
// module chunks = 1